import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@components';
import { Group } from '@mantine/core';
import { Chronometer } from '@assets/svg/icons';
import { LogoHub, LogoUnhas } from '@assets/svg/logos';
import './styles.scss';
import { useAuth } from '@unbooking/ui-auth';

export interface ISidebar {
  bgColor?: string;
  children: React.ReactNode;
  username?: string;
  hideInfo?: boolean;
  logout: () => void;
}

const Sidebar: FC<ISidebar> = ({ bgColor, children, username = '', hideInfo, logout }) => {
  const { isAuthenticated } = useAuth();
  const { t, i18n } = useTranslation();

  return (
    <aside className='sidebar' {...(bgColor ? { style: { backgroundColor: bgColor } } : {})}>
      <div className='sidebar-header'>
        <Group className='lang'>
          <Button
            className={i18n.language === 'en' ? 'active' : undefined}
            text='EN'
            variant='outline'
            onClick={() => i18n.changeLanguage('en')}
          />
          <Button
            className={i18n.language === 'fr' ? 'active' : undefined}
            text='FR'
            variant='outline'
            onClick={() => i18n.changeLanguage('fr')}
          />
        </Group>
        <div className='info-container'>
          <div className='unhas-logo'>
            <LogoUnhas />
          </div>
          {!hideInfo && (
            <div className='info'>
              {t('sidebar.infoTime')}
              <div className='time'>
                <Chronometer className='time-icon' />
                15 min
              </div>
            </div>
          )}
        </div>
      </div>
      {children}
      <div className='sidebar-footer'>
        <LogoHub className='logo' />

        {isAuthenticated && (
          <div className='info'>
            {t('sidebar.hello')} {username}
            <Button className='btn-logout' text='Logout' variant='subtle' onClick={logout} />
          </div>
        )}
      </div>
    </aside>
  );
};

export default Sidebar;
